import axios from 'axios';
import { AI_FUNCTIONS_BASE_URL, SAVE_LOAD_FUNCTIONS_BASE_URL } from './api';
import { acquireApiToken } from './auth';

let interceptorId = null;

const isProtectedApiRequest = (url = '') => (
  String(url).startsWith(AI_FUNCTIONS_BASE_URL)
  || String(url).startsWith(SAVE_LOAD_FUNCTIONS_BASE_URL)
);

const isAuthDebugEnabled = () => (
  process.env.NODE_ENV !== 'production'
  || ['localhost', '127.0.0.1'].includes(window.location.hostname)
);

const summarizeProtectedRequest = (url = '') => ({
  url,
  protectedBy: String(url).startsWith(AI_FUNCTIONS_BASE_URL) ? 'AI_FUNCTIONS_BASE_URL' : 'SAVE_LOAD_FUNCTIONS_BASE_URL',
  aiBaseUrl: AI_FUNCTIONS_BASE_URL,
  saveLoadBaseUrl: SAVE_LOAD_FUNCTIONS_BASE_URL,
});

export const configureApiAuthentication = () => {
  if (interceptorId !== null) return interceptorId;

  interceptorId = axios.interceptors.request.use(async (config) => {
    if (!isProtectedApiRequest(config.url)) return config;
    const token = await acquireApiToken();
    if (!token) {
      const error = new Error('Your session has expired. Sign in again to continue.');
      error.code = 'AUTH_REQUIRED';
      throw error;
    }
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
    if (isAuthDebugEnabled()) {
      console.groupCollapsed('[Auth] Attached bearer token to API request');
      console.info({
        ...summarizeProtectedRequest(config.url),
        method: config.method || 'get',
        tokenPresent: Boolean(token),
        tokenLength: token.length,
        tokenSegmentCount: String(token).split('.').length,
      });
      console.groupEnd();
    }
    return config;
  });

  return interceptorId;
};

export default configureApiAuthentication;
